import { render, staticRenderFns } from "./user_confirmation.vue?vue&type=template&id=5bd125f8&scoped=true"
import script from "./user_confirmation.vue?vue&type=script&lang=js"
export * from "./user_confirmation.vue?vue&type=script&lang=js"
import style0 from "./user_confirmation.vue?vue&type=style&index=0&id=5bd125f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd125f8",
  null
  
)

export default component.exports